<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <!-- 共同介面 -->
              <v-col cols="12">
                <v-autocomplete
                  v-if="taskId<=0"
                  :items="projectOptions"
                  item-text="Name"
                  item-value="ID"
                  label="專案"
                  v-model="form.ProjectID"
                  @change="onProjectChanged"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="taskId<=0 && onceOpen && form.ProjectID"
                  :items="taskOptions"
                  item-text="Name"
                  item-value="ID"
                  label="任務"
                  v-model="form.TaskID"
                  :rules="formRules.TaskID"
                ></v-autocomplete>
                <v-autocomplete
                  v-else-if="taskId<=0"
                  item-text="Name"
                  item-value="ID"
                  label="任務(請先選擇專案)"
                  readonly
                  v-model="form.TaskID"
                  :rules="formRules.TaskID"
                ></v-autocomplete>
              </v-col>
              <!-- 主管介面 -->
              <v-col
                cols="12"
                sm="12"
                md="12"
                v-if="canEditTask"
              >
                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="執行人員"
                  v-model="form.UserID"
                  :rules="formRules.user"
                ></v-autocomplete>
                <span v-show="!form.UserID">請先選擇執行人員</span>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedDate"
                      label="日期"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <!-- <span v-show="!form.UserID">請先選擇執行人員</span> -->
                  <div style="background: black;">
                    <span style="display: block">紅色表示請假</span>
                    <span style="display: block">綠色表示請假確認核准中</span>
                    <!-- <v-date-picker
                      v-model="form.Date"
                      :min="today"
                      :disabled="!form.UserID"
                      :events="getDateEventColors"
                      :allowed-dates="allowedDates"
                      @input="dateMenu = false"
                    ></v-date-picker> -->
                    <v-date-picker
                      v-model="form.Date"
                      :disabled="!form.UserID"
                      :events="getDateEventColors"
                      :allowed-dates="allowedDates"
                      @input="dateMenu = false"
                    ></v-date-picker>
                  </div>
                </v-menu>
                <v-text-field
                  v-model="form.Content"
                  label="工作內容"
                  :rules="formRules.Content"
                ></v-text-field>
                <!-- <v-text-field
                  v-model="form.Budget"
                  label="預算"
                  :rules="formRules.Budget"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :messages="BudgetConsumptionTips"
                ></v-text-field> -->
                <v-text-field
                  v-if="canEditBonus"
                  v-model="form.Bonus"
                  label="獎金"
                  :rules="formRules.Bonus"
                  type="number"
                  step="1"
                  max="1000000000"
                ></v-text-field>
                <!-- <v-chip
                  v-show="isOverBudget"
                  color="red"
                  small
                >
                  預算超標
                </v-chip> -->
                <!-- <v-text-field
                  v-model="form.EstimatedHours"
                  label="預計時數"
                  :rules="formRules.EstimatedHours"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field> -->
                <v-textarea
                  v-model="form.Remark"
                  rows="3"
                  label="主管備註"
                ></v-textarea>
              </v-col>
              <!-- 員工介面 -->
              <v-col
                v-else
                cols="12"
                sm="12"
                md="12"
              >
                <v-autocomplete
                  :items="meOptions"
                  item-text="Name"
                  item-value="ID"
                  label="執行人員"
                  v-model="form.UserID"
                  :rules="formRules.user"
                  readonly
                ></v-autocomplete>
                <v-text-field
                  v-model="form.Content"
                  label="工作內容"
                  :rules="formRules.Content"
                ></v-text-field>
                <!-- <v-text-field
                  v-model="form.EstimatedHours"
                  label="預計時數"
                  :rules="formRules.EstimatedHours"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field> -->
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedDate"
                      label="工作日期"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <!-- <span v-show="!form.UserID">請先選擇執行人員</span>
                  <span>紅色表示請假</span> -->
                  <!-- <v-date-picker
                    v-model="form.Date"
                    :min="today"
                    :disabled="!form.UserID"
                    :events="getDateEventColors"
                    :allowed-dates="allowedDates"
                    @input="dateMenu = false"
                  ></v-date-picker> -->
                  <v-date-picker
                    v-model="form.Date"
                    :disabled="!form.UserID"
                    :events="getDateEventColors"
                    :allowed-dates="allowedDates"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
                <!-- 執行狀況 -->
                <v-select
                  :items="workStatusOptions"
                  item-text="ID"
                  item-value="ID"
                  label="執行狀況"
                  v-model="form.WorkStatus"
                ></v-select>
                <!-- 處理說明 -->
                <v-textarea
                  v-model="form.Report"
                  rows="1"
                  auto-grow
                  label="處理說明"
                ></v-textarea>
                <!-- 
                <v-textarea
                  v-model="form.WorkStatus"
                  rows="3"
                  label="執行狀況"
                ></v-textarea>
                <v-textarea
                  v-model="form.Report"
                  rows="3"
                  label="處理說明"
                ></v-textarea>
                <v-text-field
                  v-model="form.ActualHours"
                  label="處理時數"
                  :rules="formRules.ActualHours"
                  type="number"
                  step="1"
                  min="0"
                        max="1000000000"
                ></v-text-field> -->
              </v-col>
              <v-col cols="3">
                <!-- 處理時數 -->
                <v-text-field
                  v-model="form.ActualHours"
                  label="處理時數"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <!-- 分鐘 -->
                <v-text-field
                  v-model="form.ActualMinutes"
                  label="分鐘"
                  type="number"
                  step="1"
                  min="0"
                  max="59"
                  maxlength="2"
                  @input="onActualMinutesChanged"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    },
    taskId: {
      type: Number,
      required: false,
      default: -1
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    workStatusOptions: [
      { ID: "準時完成" },
      { ID: "個人問題" },
      { ID: "客戶要求" },
      { ID: "部門因素" },
      { ID: "其他" }
    ],
    form: {Date: moment(new Date()).format("YYYY-MM-DD")},
    defaultForm: {
      Bonus: 0,
      Budget: 0,
      Content: "",
      Remark: "",
      UserID: 0,
      ProjectID: null,
      TaskID: null,
      // EstimatedHours: 0,
      ActualHours: 0,
      ActualMinutes: 0,
      Date: moment(new Date()).format("YYYY-MM-DD")
    },
    dateMenu: false,
    today: moment(new Date()).format("YYYY-MM-DD"),
    onceOpen: false // 第一次開啟視窗才計算 taskOptions
  }),
  computed: {
    isEditing() {
      return this.editingId > -1;
    },
    canEditBonus () {
      // return this.myLevel >= 1000 // 總經理以上隨時可以編輯獎金
      return this.myLevel >= 10 // 2023/10 移除預算 部門主管也能直接編輯獎金
    },
    formRules() {
      return {
        TaskID: [v => v != null || "請選擇任務"],
        amount: [
          v => v >= 0 || "獎金不可以是負數",
          v => parseInt(v) <= 1000000000 || "獎金不可超過10億"
        ],
        // Budget: [
        //   v => v >= 0 || "預計獎金不可以是負數",
        //   v => parseInt(v) <= 1000000000 || "預計獎金不可超過10億"
        // ],
        Content: [v => !!v || "請輸入工作內容"],
        user: [v => !!v || "請選擇執行人員"],
        // EstimatedHours: [
        //   v => !!v || "請輸入預計時數",
        //   v => parseInt(v) <= 1000000000 || "預計時數不可超過10億"
        // ],
        ActualHours: [
          v => !!v || "請輸入處理時數",
          v => parseInt(v) <= 1000000000 || "處理時數不可超過10億"
        ],
        ActualMinutes: [
          v => !!v || "請輸入處理時數",
          v => parseInt(v) <= 1000000000 || "處理時數不可超過10億"
        ]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增工作" : "編輯工作";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    userOptions() {
      return this.activeUsers
        .filter(o => AppDataSetting.findUserLevel(this, o) <= 10)
        .map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    meOptions() {
      return [this.me].map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    projectOptions() {
      return this.projects
    },
    taskOptions() {
      var filter = (o => {
        if (this.form.TaskID == o.ID) return true
        if (!o.IsActive) return false
        if (this.form.ProjectID)
          if (o.ProjectID != this.form.ProjectID) return false;

        // 如果是主管，就要選擇有預算的專案的任務
        if (this.myLevel == 10) {
          let result = this.projectDepartmentBudgetsMapOfProject[o.ProjectID] && this.projectDepartmentBudgetsMapOfProject[o.ProjectID].length
          return result
        }
        // 如果是員工 就要選擇負責人是自己的任務的專案
        if (this.myLevel == 1) {
          return o.ManagerID == this.me.ID;
        }
        return true;
      })
      var result = [{ID: 0, Name: '自動建立任務'}].concat(this.tasks.filter(filter))
      return result;
    },
    formattedDate() {
      return this.form.Date ? moment(this.form.Date).format("YYYY-MM-DD") : "";
    },
    editingIdx() {
      return this.$store.state.taskWorkingItem.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    userLeaveRecords() {
      return this.$store.state.leaveForm.list.filter(
        o => o.CreatedBy == this.form.UserID
      );
    },
    BudgetConsumptionTips() {
      if (this.taskId < 0 && !this.form.TaskID) return "";
      let taskID = this.taskId > 0 ? this.taskId : this.form.TaskID;
      let task = this.activeTaskList.find(o => o.ID == taskID);
      if (!task) return "";
      let taskWorkingItems = this.taskWorkingItems.filter(
        o => o.TaskID == taskID
      );
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => sum + item.Budget,
        0
      );
      var tips = "";
      // 1. 專案部門預算
      //tips += `部門專案預算(${this.task.ProjectStage}): ${this.projectDepartmentBudget.Budget}`;
      // 2. 任務預算
      tips += `任務預算: ${task.Amount}, 已編列 ${usedBudget}`;
      //tips += `、\n`
      return tips;
    },
    isOverBudget() {
      if (this.taskId < 0 && !this.form.TaskID) return false;
      let taskID = this.taskId > 0 ? this.taskId : this.form.TaskID;
      let task = this.activeTaskList.find(o => o.ID == taskID);
      if (!task) return false;
      let taskWorkingItems = this.taskWorkingItems.filter(
        o => o.TaskID == taskID
      );
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => (item.ID == this.form.ID ? sum : sum + item.Budget),
        0
      );
      return parseInt(usedBudget) + parseInt(this.form.Budget) > task.Amount;
    },
    ...mapGetters([
      "activeUsers",
      "me",
      "tasks",
      "activeTaskList",
      "projects",
      "myLevel",
      "userPositions",
      "projectDepartmentBudgets",
      "projectDepartmentBudgetsMapOfProject",
      "myDepartment",
      "userDepartments",
      "canEditTask",
      "taskWorkingItems"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      // if (
      //   this.myLevel >= 10 &&
      //   this.isOverBudget &&
      //   !window.confirm(`預算超標，確定仍要新增?`)
      // )
      //   return;

      this.form.Budget = parseInt(this.form.Budget) || 0;
      this.form.Bonus = parseInt(this.form.Bonus) || 0;
      this.form.EstimatedHours = parseInt(this.form.EstimatedHours) || 0;
      this.form.ActualHours = parseInt(this.form.ActualHours) || 0;
      this.form.ActualMinutes = parseInt(this.form.ActualMinutes) || 0;

      if (this.form.Budget > 1000000000) {
        return alert("預算不可大於10億");
      }
      if (this.form.Bonus > 1000000000) {
        return alert("獎金不可大於10億");
      }
      if (this.form.EstimatedHours > 1000000000) {
        return alert("預估時數不可大於10億");
      }
      if (this.form.ActualHours > 1000000000) {
        return alert("實際時數不可大於10億");
      }

      let payload = JSON.parse(JSON.stringify(this.form));
      if (payload.Date) payload.Date = moment(payload.Date).toISOString(true);

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.taskWorkingItem
          .edit(this, payload)
          .then(res => {
            this.$set(
              this.$store.state.taskWorkingItem.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        if (this.taskId > 0) payload.TaskID = this.taskId;

        this.$services.taskWorkingItem
          .add(this, payload)
          .then(res => {
            this.$store.state.taskWorkingItem.list.splice(
              0,
              0,
              res.data.result
            );
            if (payload.TaskID == 0) {
              // 重新抓取自動建立的任務
              this.$store.state.task.isFetched = false;
              this.$services.task.prepareData(this);
              // 如果目前沒有符合的部門/階段的專案預算，重新抓取專案預算..先統一refetch
              // if (!this.$store.state.projectDepartmentBudget.list.find(o=>o.DepartmentID == this.form.DepartmentID && o.ProjectStage == this.form.ProjectStage)) {
                this.$store.state.projectDepartmentBudget.isFetched = false;
                this.$services.projectDepartmentBudget.prepareData(this);
              // }
            }
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        let form = JSON.parse(
          JSON.stringify(
            this.$store.state.taskWorkingItem.list[this.editingIdx]
          )
        );
        if(form.Date)form.Date = moment(form.Date).format("YYYY-MM-DD")
        this.form = form
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (this.myLevel == 1) this.form.UserID = this.me.ID;
      }
      if (this.form.TaskID) this.form.ProjectID = (this.tasks.find(o=>o.ID == this.form.TaskID) || {}).ProjectID
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    onProjectChanged() {
      // if (this.form.TaskID) return;
      let projectFirstTask = this.activeTaskList.find(
        o => o.ProjectID == this.form.ProjectID
      );
      if (!projectFirstTask) return;
      this.form.TaskID = projectFirstTask.ID;
    },
    allowedDates(date) {
      let userLeaveRecords = this.userLeaveRecords
        .filter(
          o =>
            moment(o.Begin) <= moment(date + " 08:00") &&
            moment(date + " 18:00") <= moment(o.End)
        )
        .filter(o => o.Status == "通過");
      return userLeaveRecords.length == 0;
    },
    getDateEventColors(date) {
      let userLeaveRecords = this.userLeaveRecords.filter(
        o =>
          moment(moment(o.Begin).format("l")) <= moment(date) &&
          moment(date) <= moment(moment(o.End).format("l"))
      );
      if (userLeaveRecords.length <= 0) return false;
      if (userLeaveRecords.filter(o => o.Status == "通過").length)
        return ["red"];
      if (
        userLeaveRecords.filter(
          o => o.Status == "代理人確認中" || o.Status == "主管確認中"
        ).length
      )
        return ["green"];
      return false;
    },
    onActualMinutesChanged () {
      var n = parseInt(this.form.ActualMinutes)
      if (!n || isNaN(n)) return;
      if (n > 59) {
        this.form.ActualMinutes = ''
        this.$nextTick(()=>{
          this.form.ActualMinutes = 59
        })
      }
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) {
        if(!this.onceOpen)this.onceOpen = true
        if (!this.isEditing && this.projectOptions.length == 0) {
          alert(`您的部門並沒有「已分配預算的有效專案」，無法建立工作日誌。`);
          this.close();
        }
        this.resetForm();
      }
    }
  }
};
</script>